function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2",
  id: "Layer_2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,12H12V10h5a1,1,0,0,0,1-1V2a1,1,0,0,0-1-1H5A1,1,0,0,0,4,2V9a1,1,0,0,0,1,1h5v2H2a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H3V30a1,1,0,0,0,2,0V17H17V30a1,1,0,0,0,1,1H28a1,1,0,0,0,1-1V17h1a1,1,0,0,0,1-1V13A1,1,0,0,0,30,12ZM6,3H16V8H6ZM27,29H19V24h8Zm0-7H19V17h8Zm2-7H3V14H29Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,20.5h2a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,27.5h2a1,1,0,0,0,0-2H22a1,1,0,0,0,0,2Z"
}));

function SvgHotdesk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotdesk);
export default __webpack_public_path__ + "static/media/hotdesk.9ea68370.svg";
export { ForwardRef as ReactComponent };